import { render } from "./SectionLeaveForm.vue?vue&type=template&id=f7af3708&scoped=true"
import script from "./SectionLeaveForm.vue?vue&type=script&lang=js"
export * from "./SectionLeaveForm.vue?vue&type=script&lang=js"

import "./SectionLeaveForm.vue?vue&type=style&index=0&id=f7af3708&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7af3708"]])

export default __exports__